import { Influencer } from "types/influencer"
import InfluencerCardHeader from "./InfluencerCardHeader"
import { CampaignApplication } from "types/campaign/applications"
import InfluencerStats from "./InfluencerStats"
import { ACCOUNT_NOT_FOUND_MSG } from "constants/global"

interface InfluencerCardProps {
    language?: string
    influencer: Influencer,
    application: Pick<CampaignApplication, 'requirement_match' | 'requirement_match_details' | 'authenticity_score' | 'authenticity_score_details' | 'average_views'>
}
const InfluencerCard: React.FC<InfluencerCardProps> = ({ influencer, application, language }) => {
    return (
        <div className="influencer-card">
            <InfluencerCardHeader influencer={influencer}
                language={language}
                headerRightContent={
                    (
                        <div className="application-card-action d-flex flex-column justify-content-center gap-2">
                            <span className="application-action navigate-icon text-primary bg-primary-light"><i className="mdi mdi-arrow-top-right" /></span>
                        </div>
                    )
                }
            />
            {
                influencer.social_account ? (
                    <InfluencerStats
                        average_views={application.average_views}
                        gender_name={influencer.gender_name}
                        engagement_color={influencer.social_account.engagement_rate_details.color}
                        engagement_score={influencer.social_account.engagement_score}
                        authenticity_color={application.authenticity_score_details.color}
                        authenticity_score={application.authenticity_score}
                        requirement_match_color={application.requirement_match_details.color}
                        requirement_match={application.requirement_match}
                        followers_count={influencer.social_account.followers_count}
                    />
                ) : (
                    <div className="account-not-available-card">
                        <span className="w-75">{ACCOUNT_NOT_FOUND_MSG}</span>
                    </div>
                )
            }
        </div>
    )
}

export default InfluencerCard